
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Quels objectifs marketing atteindre avec Instagram Ads ?",
    description:
      "Découvrez comment Instagram Ads peut vous aider à atteindre des objectifs de notoriété, d’engagement et de conversion avec les conseils experts d’ALEO.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
